import { isServer } from './server';
import { PlcNextPageContext } from 'features/business/app.types';

export function handleScrollTop() {
  if (isServer()) {
    return;
  }
  window.scrollTo({ behavior: 'auto', top: 0 });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getHost(req?: any) {
  // Force https
  const protocol = 'https';
  let plcHostname = 'www.pleinchamp.com';
  if (typeof window !== 'undefined') {
    const {
      location: { hostname },
    } = window;
    plcHostname = hostname;
  } else if (req && req.get) {
    plcHostname = req.get('host');
  }

  return `${protocol}://${plcHostname}`;
}

export function isMobileDevice(ctx?: PlcNextPageContext | null): boolean {
  const userAgent = ctx?.req?.headers?.['user-agent'] ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '');

  // Basic mobile detection using user-agent (works for most smartphones and tablets)
  const isMobileUA = userAgent ? /(iPad|iPhone|Android|Mobile)/i.test(userAgent) : false;

  // On iPads running iOS 13 and above, the user-agent can mimic a desktop (e.g., Mac),
  // so we also check for touch support using maxTouchPoints > 2
  const isTouchDevice = typeof navigator !== 'undefined' ? navigator.maxTouchPoints > 2 : false;

  return isMobileUA || isTouchDevice;
}

export function getDeviceType(userAgent: string): 'Android' | 'iOS' | 'other' {
  if (/Android/i.test(userAgent)) return 'Android';
  if (/iPad|iPhone|iPod/.test(userAgent)) return 'iOS';
  return 'other';
}
